module.exports = __webpack_public_path__ + "static/media/arrow-down.6c00f28d.svg";